import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Input, Button, CardBody, Card } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import SelectComponent from '@componentes/select/select.component';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from '../../../../helpers/intlMessage';
import {filtroTipoEnum, statusSolicitacoesEnumList, tiposSolicitacoesEnumList, filtroTipoEnumList} from '../../solicitacao.utils';
import { useIntl } from 'react-intl';
import { BotaoComIcone } from 'vivace-fluent-motion';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../../../helpers';
import * as commonActions from '@common/common.action';

function Filtro({
	filtro,
	setFiltro,
	filtrar,
	setShowModalImprimir,
	showBtnImprimir,
}) {
	const carregando = useSelector((state) => state.commonReducer.showCarregando);
	const usuarios = useSelector((state) => state.commonReducer.usuarios);
	const [optionsSelect, setOptionsSelect] = useState([]);
	const [usuariosFiltro, setUsuariosFiltro] = useState([]);
	const intl = useIntl();
	const [resetSignal, setResetSignal] = useState(false);
	const dispatch = useDispatch();
	const [periodo, setPeriodo] = useState({ value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` });
	const periodos = obterListagemDePeriodos(intl);

	function translate(key) {
		return intl.formatMessage({ id: key });
	}
	useEffect(() => {
		const periodo = CommonFunctions.getPeriodosSubDays(0);
		const { periodoInicial, periodoFinal } = periodo;

		setFiltro({ periodoInicial, periodoFinal });
		setUsuariosFiltro([
			{ label: <IntlMessage id="general.requestsPanel.all" />, value: null },
			...usuarios,
		]);
	}, [usuarios]);

	const limparFiltro = () => {
		const { periodoInicial, periodoFinal } =
			CommonFunctions.getPeriodosSubDays(0);
		setFiltro({
			medico: '',
			periodoInicial,
			periodoFinal,
			tipo: '',
			value: '',
			usuarioSolicitante: null,
			usuarioExecutante: null,
		});

		setOptionsSelect([]);
		setResetSignal((prevSignal) => !prevSignal);
	};

	const onChangeTipoFiltro = (item) => {
		setFiltro({ ...filtro, tipo: item.value });
		switch (item.value) {
			case filtroTipoEnum.STATUS:
				setOptionsSelect(statusSolicitacoesEnumList);
				break;
			case filtroTipoEnum.TIPO:
				setOptionsSelect(tiposSolicitacoesEnumList);
				break;
			default:
				break;
		}
	};

	const showInput = (tipo) => {
		switch (tipo) {
			case filtroTipoEnum.NR_EXAME:
				return true;
			default:
				return false;
		}
	};

	function resetarPeriodo() {
		setPeriodo('');
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    setPeriodo(e);
    setFiltro({ ...filtro, periodoInicial: payload.dtinicial, periodoFinal: payload.dtfinal });
	}

	function mudarIntervaloPeriodo(val) {
		let payload = changePeriod(val);

    setFiltro({ ...filtro, periodoInicial: payload.start, periodoFinal: payload.end });
	}

  function eventoOnKeyPressData(event) {
		if (event.key === "Enter") {
			const result = CommonFunctions.validaData(filtro.periodoInicial, filtro.periodoFinal, intl);

			if (!result.valid) {
			dispatch(commonActions.showAlerta('alerta', result.message, 3000));
			return;
			}

			filtrar(filtro);
		}
	}

	return (
		<Card>
			<CardBody>
				<Row>
					<Col sm={'2'}>
						<SelectComponent
							key={`usuarioSolicitante-${resetSignal}`}
							options={usuariosFiltro}
							onChange={(event) =>
								setFiltro({ ...filtro, usuarioSolicitante: event.value })
							}
							placeholder={translate('general.requestsPanel.requester')}
							styles={{ borderColor: 'transparent' }}
							disabled={carregando}
						/>
					</Col>
					<Col sm={'2'}>
						<SelectComponent
							key={`usuarioExecutante-${resetSignal}`}
							options={usuariosFiltro}
							onChange={(event) =>
								setFiltro({ ...filtro, usuarioExecutante: event.value })
							}
							placeholder={translate('general.requestsPanel.performer')}
							styles={{ borderColor: 'transparent' }}
							disabled={carregando}
						/>
					</Col>

					<Col sm={'2'}>
						<SelectComponent
							key={`tipo-${resetSignal}`}
							options={filtroTipoEnumList}
							onChange={(item) => onChangeTipoFiltro(item)}
							placeholder={translate('general.requestsPanel.searchType')}
							styles={{ borderColor: 'transparent' }}
							disabled={carregando}
						/>
					</Col>
					<Col
						sm={'3'}
						style={{
							display:
								filtro.tipo !== filtroTipoEnum.TIPO &&
								filtro.tipo !== filtroTipoEnum.STATUS
									? 'none'
									: 'initial',
						}}
					>
						<SelectComponent
							options={optionsSelect}
							placeholder={translate('general.requestsPanel.selectAnOption')}
							onChange={(event) => setFiltro({ ...filtro, value: event.value })}
							styles={{ borderColor: 'transparent' }}
							disabled={carregando}
						/>
					</Col>
					<Col
						sm={'auto'}
						style={{
							padding: 0,
							display:
								filtro.tipo !== filtroTipoEnum.DATA_SOLICITACAO
									? 'none'
									: 'initial',
						}}
					>
						<Row style={{ marginRight: '15px' }}>
							<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto'}}>
								<div className="label-data"><IntlMessage id="period.name"/></div>
								<div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
								<SelectComponent
									isClearable
									className="filtro-data"
									noOptionsMessage={() => {
									return intl.formatMessage({id: "dashboards.reports.noItemsFound"});
									}}
									name="form-field-period"
									placeholder={`${intl.formatMessage({id: "dashboards.general.selectPeriod"})}`}
									value={periodo}
									onChange={(e) => {
									periodoAlterado(e);
									e && e.value ? mudarIntervaloPeriodo(e.value) : mudarIntervaloPeriodo('todos');
									}}
									options={periodos}
								/>
								</div>

								{periodo && periodo.value === 'outro' && (
								<React.Fragment>
									<DebounceInput
									name="periodoDe"
									type="date"
									style={{width: '130px', display: 'block'}}
									className="filtro-data"
									value={filtro.periodoInicial}
									onChange={e => setFiltro({ ...filtro, periodoInicial: e.target.value })}
									onKeyPress={(e) => eventoOnKeyPressData(e)}
									/>
									<DebounceInput
									name="periodoAte"
									type="date"
									style={{width: '130px', display: 'block'}}
									className="filtro-data"
									value={filtro.periodoFinal}
									onChange={e => setFiltro({ ...filtro, periodoFinal: e.target.value })}
									onKeyPress={(e) => eventoOnKeyPressData(e)}
									/>
								</React.Fragment>
								)}
							</div>
						</Row>
					</Col>
					<Col
						sm={'3'}
						style={{
							display: showInput(filtro.tipo) ? 'initial' : 'none',
						}}
					>
						<Input
							style={{
								height: '45px',
								borderRadius: '5px',
								fontSize: '13px',
							}}
							type={'text'}
							onChange={(event) =>
								setFiltro({ ...filtro, value: event.target.value })
							}
							disabled={carregando}
						/>
					</Col>
					<Col sm={'auto'}>
						<Button
						className='btn btn-primary'
						onClick={() => filtrar(filtro)}
						style={{ height: '38px', width: '38px' }}
						disabled={carregando || !filtro.tipo}
						>
						<i className='icons-btn mv-basico-pesquisar'></i>
						</Button>
					</Col>
					<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: 'auto', height:'38px' }}>
						<BotaoComIcone
							className="btn btn-icon"
							color="secondary"
							icone="mv-basico-excluir_todos"
							style={{ marginLeft: 0 }}
							height={38}
							onClick={() => limparFiltro()}
						>
							<IntlMessage id="dashboards.general.clearFilters" />
						</BotaoComIcone>
					</div>
					{showBtnImprimir && (
						<Col>
							<Button
								className="btn btn-imprimir right btn-success"
								onClick={() => setShowModalImprimir(true)}
							>
								<i className="icons-btn mv-basico-imprimir"></i>
								<IntlMessage id="general.requestsPanel.print" />
							</Button>
						</Col>
					)}
				</Row>
			</CardBody>
		</Card>
	);
}

export default Filtro;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Solicitacoes/Filtro/index.js